import * as React from 'react';
export var CnTabContext = React.createContext({
    activeKey: -1,
    fullWidth: true,
    change: function () { },
});
